import { render, staticRenderFns } from "./HistorialTab.vue?vue&type=template&id=60f5dbe6&scoped=true"
import script from "./HistorialTab.vue?vue&type=script&lang=js"
export * from "./HistorialTab.vue?vue&type=script&lang=js"
import style0 from "./HistorialTab.vue?vue&type=style&index=0&id=60f5dbe6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f5dbe6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f5dbe6')) {
      api.createRecord('60f5dbe6', component.options)
    } else {
      api.reload('60f5dbe6', component.options)
    }
    module.hot.accept("./HistorialTab.vue?vue&type=template&id=60f5dbe6&scoped=true", function () {
      api.rerender('60f5dbe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/tabs/HistorialTab.vue"
export default component.exports